import ApplyToProgramContainer from './apply_to_program_container';

const ApplyToProgram = ApplyToProgramContainer;
export default ApplyToProgram;
